import { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useStyles } from "../style";

interface DashboardTableListProps {
  tableData: any;
  data: any;
}

export const DashboardTableList: FC<DashboardTableListProps> = ({ tableData, data }) => {
  const classes = useStyles();
  return (
    <TableContainer className={classes.tableContainer}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell className={`${classes.tableHeadCell} ${classes.firstCell}`} colSpan={2}>
              <Typography>#</Typography>
            </TableCell>
            {tableData
              .filter((item: any) =>
                data.every((dataItem: any) => dataItem.status !== 2) ? item.id !== "reason" : true,
              )
              .map((item: any) => (
                <TableCell
                  colSpan={2}
                  key={`head-${item.id}-cell`}
                  className={`${classes.tableHeadCell}`}
                >
                  <Typography className={`${classes.cellText} ${classes.tableCellBorderLeft}`}>
                    {item.label}
                  </Typography>
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((dataItem: any, index: number) => (
            <TableRow className={`${index !== 0 && classes.tableRowTopBorder}`}>
              <TableCell
                className={`${classes.tableCell} ${classes.firstCell} ${index !== 0 && classes.tableRowTopBorder}`}
                colSpan={2}
              >
                <Typography>{index + 1}</Typography>
              </TableCell>
              {tableData
                .filter((item: any) => (dataItem.status !== 2 ? item.id !== "reason" : true))
                .map((itemCol: any) => (
                  <TableCell
                    key={`body-${itemCol.id}-${dataItem[itemCol.id]}-cell`}
                    className={`${classes.tableCell} ${index !== 0 && classes.tableRowTopBorder}`}
                    colSpan={2}
                  >
                    <Typography className={`${classes.cellText} ${classes.tableCellBorderLeft}`}>
                      {dataItem[itemCol.id]}
                    </Typography>
                  </TableCell>
                ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
